import React, { useEffect, useState } from "react";
import {
  DndContext,
  MouseSensor,
  TouchSensor,
  useSensor,
  useSensors,
} from "@dnd-kit/core";

import { Droppable } from "./Droppable";
import { Draggable } from "./Draggable";
import Imagen1 from "../images/modulo12/esposos.png";
import Imagen2 from "../images/modulo12/ovejas.png";

export default function App({ items }) {
  const containers = ["A", "B"];
  const [parents, setParents] = useState(null);

  useEffect(() => {
    const dragables = items.map((item, idx) => (
      <Draggable id={"item" + (idx + 1)} key={idx} className="bg-white">
        {item}
      </Draggable>
    ));
    setParents({
      item1: {
        parent: "",
        content: dragables[0],
        correctParent: "B",
        valid: null,
      },
      item2: {
        parent: "",
        content: dragables[1],
        correctParent: "C",
        valid: null,
      },
      item3: {
        parent: "",
        content: dragables[2],
        correctParent: "A",
        valid: null,
      },
      item4: {
        parent: "",
        content: dragables[3],
        correctParent: "A",
        valid: null,
      },
      item5: {
        parent: "",
        content: dragables[4],
        correctParent: "A",
        valid: null,
      },
    });
  }, [items]);

  const mouseSensor = useSensor(MouseSensor);
  const touchSensor = useSensor(TouchSensor);

  const sensors = useSensors(mouseSensor, touchSensor);

  return (
    <div className="">
      {parents ? (
        <DndContext onDragEnd={handleDragEnd} sensors={sensors}>
          <div className="d-flex justify-content-center my-3 flex-wrap">
            {Object.keys(parents).map((item, idx) =>
              parents[item].parent === "" ? parents[item].content : null
            )}
          </div>
          <div className="drops-container-2">
            {parents &&
              containers.map((id, idx) => (
                // We updated the Droppable component so it would accept an `id`
                // prop and pass it to `useDroppable`
                <Droppable key={id} id={id}>
                  <div className="border-2 border rounded shadow-sm p-0 card-book">
                    <div className="mh-100 py-2">
                      {Object.keys(parents).map((item, idx) =>
                        parents[item].parent === id
                          ? parents[item].content
                          : null
                      )}
                    </div>
                  </div>
                  {id === "A" ? (
                    <div>
                      <img
                        src={Imagen1}
                        alt="Electores"
                        className="img-fluid"
                      />
                      <p>
                        Pepe Murakami se levanta muy temprano a trabajar todos
                        los días. Cuando llega de vuelta a su casa cuida a su
                        esposa que está enferma.
                      </p>
                    </div>
                  ) : null}
                  {id === "B" ? (
                    <div>
                      {" "}
                      <img
                        src={Imagen2}
                        alt="Electores"
                        className="img-fluid"
                      />
                      <p>
                        Eli Páucar es la primera de su clase. Su profesora cree
                        que le irá muy bien en la universidad. Cuando no está en
                        el colegio, Eli pastorea sus animales. Un día la mordió
                        un perro y ella se curó la herida solita.
                      </p>
                    </div>
                  ) : null}
                </Droppable>
              ))}
          </div>
        </DndContext>
      ) : null}
    </div>
  );

  function handleDragEnd(event) {
    const { over } = event;
    if (over) {
      const newParent = over.id;
      const item = event.active.id;
      //console.log('item',item );
      //console.log('parents', parents)
      setParents({
        ...parents,
        [item]: { ...parents[item], parent: newParent },
      });
    }

    // If the item is dropped over a container, set it as the parent
    // otherwise reset the parent to `null`
    //setParent(over ? over.id : null);
  }
}
